import React from 'react';

// Page routes
const Login = React.lazy(() => import('../views/Authentication/Login'));
const Logout = React.lazy(() => import('../views/Authentication/Logout'));
const Page404 = React.lazy(() => import('../views/Page404/Page404'));
const Page500 = React.lazy(() => import('../views/Page500/Page500'));
const Unauthorised = React.lazy(() => import('../views/Unauthorised'));

//Identity Server Authenication routes
const CallbackPage = React.lazy(() => import('../views/Callback'));
const SilentRenew = React.lazy(() => import('../views/SilentRenew'));

const routesPublic = [
  { path: '/callback', exact: true, name: 'IDS4 Callback', component: CallbackPage },
  { path: '/silent-renew', exact: true, name: 'Order Entry', component: SilentRenew },
  { path: '/unauthorised', exact: true, name: 'Unauthorised', component: Unauthorised },
  { path: '/login', exact: true, name: 'Login', component: Login },
  { path: '/logout', exact: true, name: 'Logout', component: Logout },
  { path: '/404', exact: true, name: 'No Found', component: Page404 },
  { path: '/500', exact: true, name: 'Error', component: Page500 },
];

export default routesPublic;
